const templateComponentPath = '/template-component';
export default templateComponentPath;
